import React from 'react';
import { Menu } from 'antd';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import styles from './StyledMenu.module.scss';

const { Item } = Menu;

const StyledMenu = ({
  className,
  items,
  itemKeyName = 'key',
  itemContentName = 'content',
  selectedKeys = [],
  disabled,
  ...props
}) => {
  return (
    <Menu
      {...props}
      className={cn(styles.root, className)}
      selectedKeys={selectedKeys}
      mode="horizontal"
    >
      {items.map((item) => (
        <Item
          key={item[itemKeyName]}
          disabled={disabled}
        >
          {item.link ? (
            <Link to={item.link}>{item[itemContentName]}</Link>
          ) : (
            item[itemContentName]
          )}
        </Item>
      ))}
    </Menu>
  );
};

export default StyledMenu;
